module.exports = __webpack_public_path__ + "img/KFK_WHAT.e965d773.png";